export function exportFile(response, fileNmae) {
    const blob = new Blob([response.data], { type: response.data.type }); /// / 建立 blob
    const downloadElement = document.createElement('a'); /// / 建立 <a> 元素，用以連結 blob url
    const href = window.URL.createObjectURL(blob); /// / 產生 blob url
    downloadElement.href = href; /// / 放置 blob url
    downloadElement.download = fileNmae; /// / 下載檔案與檔案設置
    document.body.appendChild(downloadElement); /// / 生成 <a> 元素
    downloadElement.click(); /// / 執行下載
    document.body.removeChild(downloadElement); /// / 下載完成，移除 <a> 元素
    window.URL.revokeObjectURL(href); /// / 釋放 blob 對象
}
